import { NEWBUILDING_KPN_CHAT } from '../../constants/experiments';
import { IApplicationState } from '../../types/redux';
import { isAbUseExperimentActive } from '../../utils/experiments';

export function selectNewbuildingKpnChatEnabled(state: IApplicationState): boolean {
  const { experiments } = state;
  const isExperimentEnabled = isAbUseExperimentActive(experiments, NEWBUILDING_KPN_CHAT, 'B');

  const isKpnChatEnabled = state.newbuilding.kpnChatEnabled || false;

  return isKpnChatEnabled && isExperimentEnabled;
}
